import { useContext } from 'react';
import IdentityContext from '../../contexts/IdentityContext';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ isTeacherAlike, children }: { isTeacherAlike: boolean; children: React.ReactNode }) {
  const { identity } = useContext(IdentityContext);

  if (isTeacherAlike !== identity.isTeacherAlike) return <Navigate to=".." replace />;

  return children;
}

export default ProtectedRoute;
